<template>
  <div
    class="spinner-wheel-winner-popup _container animate__bounceIn animate__animated"
    :class="{ '--dark': $store.state.slideActive.textColour == '#ffffff' }"
    :style="{}"
    @click="closeWinnerPopup"
  >
    <div class="spinner-wheel-winner-popup_container">
      <div class="spinner-wheel-winner-popup _close-icon">
        <aha-icon
          name="close"
          viewBox="0 0 24 24"
        />
      </div>
      <div class="spinner-wheel-winner-popup _winner-name">
        The result is...
      </div>
      <spinner-wheel-label
        class="transform scale-150 _popup rounded-lg"
        :background-color="backgroundColor"
        :text="text"
        :variant="variant"
      />

      <div class="btn-remove-winner-entry" @click="removeWinnerEntry" v-tooltip="'Remove this entry for the next spin'">
        <svg
          width="17"
          height="19"
          viewBox="0 0 17 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M6.17138 14.6589C6.17138 14.9742 5.91344 15.2321 5.59818 15.2321C5.28293 15.2321 5.02499 14.9742 5.02499 14.6589V7.20741C5.02499 6.89215 5.28293 6.63422 5.59818 6.63422C5.91344 6.63422 6.17138 6.89215 6.17138 7.20741V14.6589ZM9.03734 14.6589C9.03734 14.9742 8.7794 15.2321 8.46414 15.2321C8.14889 15.2321 7.89095 14.9742 7.89095 14.6589V7.20741C7.89095 6.89215 8.14889 6.63422 8.46414 6.63422C8.7794 6.63422 9.03734 6.89215 9.03734 7.20741V14.6589ZM11.9033 14.6589C11.9033 14.9742 11.6454 15.2321 11.3301 15.2321C11.0148 15.2321 10.7569 14.9742 10.7569 14.6589V7.20741C10.7569 6.89215 11.0148 6.63422 11.3301 6.63422C11.6454 6.63422 11.9033 6.89215 11.9033 7.20741V14.6589ZM11.8137 1.22256L13.1285 3.19506H15.629C16.1055 3.19506 16.4888 3.58018 16.4888 4.05485C16.4888 4.53132 16.1055 4.91464 15.629 4.91464H15.3425V15.8053C15.3425 17.3887 14.0599 18.6713 12.4765 18.6713H4.4518C2.86907 18.6713 1.58584 17.3887 1.58584 15.8053V4.91464H1.29924C0.824567 4.91464 0.439453 4.53132 0.439453 4.05485C0.439453 3.58018 0.824567 3.19506 1.29924 3.19506H3.80051L5.11455 1.22256C5.48713 0.664312 6.11406 0.329102 6.78398 0.329102H10.1443C10.8142 0.329102 11.4412 0.664347 11.8137 1.22256ZM5.86687 3.19506H11.0614L10.3808 2.17621C10.327 2.09668 10.2375 2.04868 10.1443 2.04868H6.78398C6.69083 2.04868 6.56903 2.09668 6.54753 2.17621L5.86687 3.19506ZM3.30541 15.8053C3.30541 16.4394 3.81878 16.9517 4.4518 16.9517H12.4765C13.1106 16.9517 13.6229 16.4394 13.6229 15.8053V4.91464H3.30541V15.8053Z" fill="#313131" />
        </svg>
        &nbsp;
        Remove entry
      </div>
    </div>
  </div>
</template>
<script>

import Util from '@/util'
import SpinnerWheelLabel from './SpinnerWheelLabel.vue'

export default {
  components: {
    SpinnerWheelLabel,
  },
  props: {
    closeShowWinner: {
      type: Function,
      default: () => null,
    },
    text: {
      type: String,
      default: '',
    },
    backgroundColor: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      firework: null,
    }
  },
  mounted() {
    this.firework = Util.firework()
    const labelEl = this.$el.querySelector('.spinner-wheel-label._container')
    if (labelEl) {
      const rgb = labelEl.style.backgroundColor // vue will convert whatever color into rgb ;)
      labelEl.style.boxShadow = `0px 14px 28px ${rgb.replace(')', ', 0.3)')}`
    }
  },
  destroyed() {
    if (this.firework) this.firework.stopFirework()
  },
  methods: {
    closeWinnerPopup() {
      if (this.closeShowWinner) this.closeShowWinner()
      if (this.firework) this.firework.stopFirework()
    },
    removeWinnerEntry() {
      this.$emit('remove-winner-entry')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.spinner-wheel-winner-popup {
  &._container {
    width: 1280px;
    background-color: rgba(255, 255, 255, 0.95);
    z-index: $highest-z-index - 2; // high z-index, but lower than firework's canvas
    @apply fixed top-0 right-0 h-full;
    @apply flex items-center justify-center flex-col;
  }

  .spinner-wheel-winner-popup_container{
    position: absolute;
    width: 556px;
    height: 274px;
    left: 361px;
    top: 230.17px;
    background: #FFFFFF;
    box-shadow: 0px 8px 14px rgb(82 95 127 / 13%);
    border-radius: 12px;
    ._winner-name{
      display: block;
      margin-top: 50px;
      margin-bottom: 12px;
      padding: 10px 0;
      font-style: normal;
      font-weight: 700;
      font-size: 24px;
      line-height: 33px;
      align-items: center;
      text-align: center;
    }
    .spinner-wheel-label._container._popup{
      max-width: 312px;
      margin: 0 auto;
    }
    .btn-remove-winner-entry{
      display: flex;
      align-items: center;
      justify-content: center;

      margin-top: 54px;
      margin-left: auto;
      margin-right: auto;
      width: fit-content;

      font-style: normal;
      font-weight: 700;
      font-size: 18px;
      line-height: 25px;
      color: #313131;

      &:hover{
        color: #FF4954;
        cursor: pointer;
        svg{
          path{
            fill: #FF4954;
          }
        }
      }
    }
  }

  &.--dark {
    background-color: rgba(0, 0, 0, 0.8);
  }

  &._winner-name {
    font-size: 20px;
    line-height: 20px;
    @apply mb-6 font-bold;
  }

  &._close-icon {
    @apply cursor-pointer absolute right-4 top-4 text-base-70;
    @apply p-2 hover:text-primary-90;

    @media (max-width: 768px) {
      top: 4rem;
      right: 3rem;
    }
  }
}
</style>
